// src/stone/icons/Telephone.tsx
import { jsx } from "react/jsx-runtime";
var Telephone = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "m22.795 16.263.002.002c.21.212.423.435.596.655.163.207.431.581.549 1.098.136.6.006 1.091-.098 1.376-.043.117-.09.223-.113.273l-.013.03-.046.102-.002.006c-.23.546-.51 1.07-.837 1.564l-.004.007c-.628.943-1.307 1.687-2.4 2.195-.587.274-1.424.536-2.637.385-1.12-.14-2.453-.618-4.132-1.558v-.001c-2.646-1.484-4.522-2.79-6.912-5.173-2.373-2.366-3.57-3.95-5.203-6.917C-.115 7.29-.325 5.059.377 3.56c.512-1.094 1.263-1.77 2.2-2.391l.008-.006A9.7 9.7 0 0 1 4.149.329l.008-.003.128-.057.005-.002c.05-.022.156-.07.273-.112a2.4 2.4 0 0 1 1.37-.097c.518.116.892.384 1.1.546.22.173.443.386.654.595.543.535 1.119 1.328 1.573 2.02.468.71.919 1.484 1.187 2.059v.002l.004.006c.126.27.266.574.37.853.108.29.232.7.233 1.183.002 1.003-.542 1.742-.826 2.127q-.014.018-.026.036c-.068.092-.133.178-.187.248l-.007.01-.077.1.009.02c.088.186.217.424.39.695a9.856 9.856 0 0 0 3.098 3.092 6 6 0 0 0 .709.386l.11-.084.012-.009.231-.175.063-.047c.37-.277 1.129-.848 2.13-.847.517 0 .945.147 1.234.265.263.107.552.253.806.381l.043.022c.525.264 1.275.696 1.991 1.16.686.443 1.495 1.013 2.038 1.561M6.283 2.623c-.736-.727-.816-.692-1.202-.518l-.156.068a7.7 7.7 0 0 0-1.242.662c-.77.51-1.196.935-1.495 1.573-.298.638-.432 2.134 1.11 4.935 1.541 2.8 2.623 4.233 4.862 6.465s3.96 3.433 6.478 4.845c3.113 1.743 4.307 1.403 4.947 1.105s1.067-.72 1.579-1.49a7.7 7.7 0 0 0 .663-1.24q.036-.087.068-.155c.174-.385.21-.465-.52-1.201-.763-.77-2.612-1.892-3.509-2.344-1.168-.589-1.264-.637-2.183.046l-.212.16c-.502.384-.893.683-1.524.549-.717-.153-2.275-1.015-3.639-2.375s-2.276-2.962-2.43-3.677c-.132-.619.16-1.004.535-1.495L8.59 8.3c.635-.866.587-1.01.044-2.178-.423-.909-1.579-2.74-2.35-3.5",
        clipRule: "evenodd"
      }
    )
  }
);
var Telephone_default = Telephone;

export {
  Telephone_default
};
